import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_URL = `${API_BASE_URL}/api/assets`;
const MAINTENANCE_API_URL = `${API_BASE_URL}/api/maintenance`;

const complianceService = {
  // Create compliance log (stored as maintenance with type 'compliance')
  createCompliance: async (assetId, userId, checklist, dueDate, priority = 'medium', notes = '') => {
    try {
      const response = await axios.post(`${MAINTENANCE_API_URL}`, {
        assetId,
        maintenanceType: 'compliance',
        checklist,
        priorityLevel: priority,
        expectedCompletionDate: dueDate,
        sentToId: userId,
        notes
      }, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error creating compliance:', error);
      throw error;
    }
  },

  // Get all compliance logs
  getAllComplianceLogs: async () => {
    try {
      const response = await axios.get(`${MAINTENANCE_API_URL}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      });
      // Filter for compliance type logs
      if (response.data && Array.isArray(response.data.data)) {
        return {
          ...response.data,
          data: response.data.data.filter(log => log.maintenanceType === 'compliance')
        };
      }
      return response.data;
    } catch (error) {
      console.error('Error fetching compliance logs:', error);
      throw error;
    }
  },

  // Update compliance log
  updateCompliance: async (logId, updateData) => {
    try {
      const response = await axios.put(`${MAINTENANCE_API_URL}/${logId}`, updateData, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error updating compliance:', error);
      throw error;
    }
  },

  // Get assets with compliance dates approaching (due soon)
  getComplianceDueSoon: async (daysAhead = 30) => {
    try {
      const response = await axios.get(`${API_URL}/compliance/due-soon`, {
        params: { daysAhead },
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching due-soon compliance:', error);
      throw error;
    }
  },

  // Get all assets with compliance status (for filtering)
  getComplianceAssets: async (type = 'due') => {
    try {
      if (type === 'completed') {
        // Get completed assets (dates in past)
        const response = await axios.get(`${API_URL}/compliance/completed`, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        });
        return response.data;
      } else {
        // Get due assets (future dates)
        const response = await axios.get(`${API_URL}/compliance/due-soon`, {
          params: { daysAhead: 365 },
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        });
        return response.data;
      }
    } catch (error) {
      console.error('Error fetching compliance assets:', error);
      throw error;
    }
  },

  // Get asset user's compliance due assets
  getMyAssetsComplianceDues: async () => {
    try {
      const response = await axios.get(`${API_URL}/compliance/my-assets`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching my assets compliance:', error);
      throw error;
    }
  },

  // Get compliance statistics
  getComplianceStats: async () => {
    try {
      const response = await axios.get(`${API_URL}/compliance/stats`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching compliance stats:', error);
      throw error;
    }
  }
};

export default complianceService;
